<template>
  <td
    v-if="actions && actions.length"
    :class="['justify-end align-center layout pr-2 pl-1', cellClass]"
  >
    <v-btn
      color="grey"
      icon
      flat
      small
      v-for="action in actions"
      :key="action.icon"
      :to="action.to"
      :href="action.href"
      @click="onClick(action)"
    >
      <v-icon>{{ action.icon }}</v-icon>
    </v-btn>
  </td>

  <td v-else-if="typeof value === 'boolean'" :class="cellClass">
    <v-checkbox :input-value="value" disabled hide-details />
  </td>

  <td v-else :class="cellClass" @click="onClick()">
    <v-tooltip bottom v-if="tooltip">
      <template v-slot:activator="{ on }">
        <span v-on="on">{{ value }}</span>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
    <span v-else>{{ value }}</span>
  </td>
</template>

<script>
function getProperty(path, obj = self, separator = '.') {
  let properties = Array.isArray(path) ? path : path.split(separator);
  return properties.reduce((prev, curr) => prev && prev[curr], obj);
}

export default {
  props: {
    header: {
      type: Object,
      default: () => ({
        value: '',
      }),
    },
    row: {
      type: Object,
      default: () => ({}),
    },
    tooltip: {
      type: String,
      default: null,
    },
  },
  computed: {
    value() {
      let value = getProperty(this.header.value, this.row);
      if (typeof this.header.format === 'function') {
        value = this.header.format.apply(this, [value, this.row]);
      }
      return value;
    },

    actions() {
      if (typeof this.header.actions === 'function') {
        return this.header.actions(this.row);
      }
      return this.header.actions;
    },

    cellClass() {
      if (typeof this.header.cellClass === 'function') {
        return this.header.cellClass(this.row);
      }
      return this.header.cellClass;
    },
  },

  methods: {
    onClick(action) {
      this.$emit('action', { action, row: this.row });
    },
  },
};
</script>

<style scoped>
td:not(.layout) {
  cursor: pointer;
}
</style>
